import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParamsService {

  constructor(
    private http: HttpClient
  ) { }

  getMessages(params) {
    return this.http.get(environment.api.serverUrl + '/messages', {params});  
  }

  addMessage(body) {
    return this.http.post(environment.api.serverUrl + '/messages', body);
  }

  editMessage(id, body) {
    return this.http.put(environment.api.serverUrl + '/messages/' + id, body);
  }

  deleteMessage(id) {
    return this.http.delete(environment.api.serverUrl + '/messages/' + id,);
  }
}
